// extracted by mini-css-extract-plugin
export default {"map":"rx1Ch_SlE3olhFXKko2g"};